import { Capacitor } from "@capacitor/core";
import saveCsvFile from "helpers/saveCsvFile";
import { showErrorMessage } from "helpers/toastMessage";

export const TEMPLATE_HREF = "/other/off_platform_receivables_template.csv";
export const TEMPLATE_FILENAME = "off_platform_receivables_template.csv";

// HP-9360: the Android WebView ignores a download link, so on native the bundled template is read
// and handed to the same save path as the generated CSVs. Web keeps the plain link.
export const downloadTemplateOnNative = async (event: { preventDefault: () => void }) => {
  if (!Capacitor.isNativePlatform()) {
    return;
  }
  event.preventDefault();
  try {
    const response = await fetch(TEMPLATE_HREF);
    if (!response.ok) {
      throw new Error(`Template request failed with ${response.status}`);
    }
    await saveCsvFile(await response.text(), TEMPLATE_FILENAME);
  } catch {
    showErrorMessage(`Couldn't save ${TEMPLATE_FILENAME}. Please try again.`);
  }
};
